module.exports = __webpack_public_path__ + "static/media/community-blue.64c21a23.svg";